import { render, staticRenderFns } from "./checked-question.vue?vue&type=template&id=512f018c&"
import script from "./checked-question.vue?vue&type=script&lang=js&"
export * from "./checked-question.vue?vue&type=script&lang=js&"
import style0 from "./checked-question.vue?vue&type=style&index=0&id=512f018c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports